/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';

const Close = (props) => (
  <SvgIcon
    style={{
      width: '12px',
      height: '12px',
    }}
    viewBox="0 0 12 12"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{props.title}</title>
    <defs>
      <rect id="path-1" x="0" y="0" width="12" height="12" rx="6" />
    </defs>
    <g id="Registration-UI" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="3.11---Trust-trustee---Desktop-HD" transform="translate(-497.000000, -1023.000000)">
        <g id="Attachments" transform="translate(318.000000, 1002.000000)">
          <g id="File" transform="translate(24.000000, 15.000000)">
            <g id="Close" transform="translate(155.000000, 6.000000)">
              <mask id="mask-2" fill="white">
                <use xlinkHref="#path-1" />
              </mask>
              <use id="BG-Circle" fill="#FAFBFB" xlinkHref="#path-1" />
              <g id="Icon" transform="translate(1.000000, 1.000000)" fill="#475F7B">
                <path d="M7.71375009,2.59420456 C7.89147737,2.41693183 7.89147737,2.12875001 7.71375009,1.95147727 C7.53647736,1.77375 7.24875009,1.77375 7.07102281,1.95147727 L4.83284096,4.18965913 L2.59420456,1.95147727 C2.41693183,1.77375 2.12875001,1.77375 1.95147727,1.95147727 C1.77375,2.12875001 1.77375,2.41693183 1.95147727,2.59420456 L4.18965913,4.83284096 L1.95147727,7.07102281 C1.77375,7.24875009 1.77375,7.53647736 1.95147727,7.71375009 C2.12875001,7.89147737 2.41693183,7.89147737 2.59420456,7.71375009 L4.83284096,5.47556824 L7.07102281,7.71375009 C7.24875009,7.89147737 7.53647736,7.89147737 7.71375009,7.71375009 C7.89147737,7.53647736 7.89147737,7.24875009 7.71375009,7.07102281 L5.47556824,4.83284096 L7.71375009,2.59420456 Z" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

Close.propTypes = {
  title: PropTypes.string,
};

Close.defaultProps = {
  title: '',
};

export default Close;
